module.exports = __webpack_public_path__ + "38b534efcb265aa8cef377e6763009bf.svg";